/**
 * De dónde salió la respuesta (GKTIBO-75).
 *
 * **No es un detalle debajo de la burbuja: es la función de la pantalla.** El
 * bot ya responde en WhatsApp; lo que acá se ve y en ningún otro lado es si lo
 * que dijo salió de algún lado — y sobre todo cuándo no salió de ninguno.
 *
 * El 2026-09-21 el bot dijo «ya avisé al equipo de urgencia» tres veces sin
 * llamar a ninguna herramienta. Se descubrió leyendo logs, un día después.
 */

import { probar as t } from './textos-probar';

export type Origen =
  | { tipo: 'conocimiento'; secciones: string[] }
  | { tipo: 'herramientas'; cuantas: number }
  | { tipo: 'ninguno' };

/** Lo que se muestra debajo de la burbuja. Es la función de la pantalla. */
export function DeDondeSalio({ origen }: { origen: Origen }) {
  if (origen.tipo === 'conocimiento') {
    return (
      <p className="probar-origen" data-testid="probar-origen">
        {t.salioDe} <strong>{origen.secciones.join(', ')}</strong>
      </p>
    );
  }

  if (origen.tipo === 'herramientas') {
    // Cuántas, nunca cuáles: el endpoint devuelve un contador, y decir
    // «consultó tus tickets» derivándolo de un número sería inventar.
    return (
      <p className="probar-origen" data-testid="probar-origen">
        {t.consulto(origen.cuantas)}
      </p>
    );
  }

  return (
    <p className="probar-origen es-sin-fuente" data-testid="probar-sin-fuente" role="note">
      {t.sinFuente}
    </p>
  );
}
